/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content/SubmitAction",
  disabled
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  disabled
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 disabled={disabled}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send pay request"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}